var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageConfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "manageConfIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 282",
    fill: "#a1a1a1",
    stroke: "#707070",
    d: "M0 0h54v54H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "manageConfIcon_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 338",
    fill: "none",
    d: "M0 0h54v54H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "SettingIcon",
    clipPath: "url(#manageConfIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 342",
    clipPath: "url(#manageConfIcon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 365",
    d: "M10.711 31.591a17.179 17.179 0 001.538 3.651l-1.856 2.34a1.921 1.921 0 00.143 2.545l3.2 3.2a1.913 1.913 0 002.545.144l2.325-1.84a16.887 16.887 0 003.795 1.606l.349 2.992a1.916 1.916 0 001.9 1.7h4.522a1.916 1.916 0 001.9-1.7l.333-2.886a17.076 17.076 0 004.068-1.644l2.25 1.78a1.921 1.921 0 002.545-.144l3.2-3.2a1.913 1.913 0 00.144-2.545l-1.75-2.219a16.694 16.694 0 001.674-4l2.7-.311a1.916 1.916 0 001.7-1.9v-4.522a1.916 1.916 0 00-1.7-1.9l-2.666-.311a16.805 16.805 0 00-1.606-3.954l1.636-2.068a1.921 1.921 0 00-.144-2.545l-3.189-3.19a1.913 1.913 0 00-2.542-.143l-2.01 1.589a16.861 16.861 0 00-4.158-1.742l-.3-2.6a1.916 1.916 0 00-1.9-1.7h-4.532a1.916 1.916 0 00-1.9 1.7l-.3 2.6a16.784 16.784 0 00-4.265 1.8l-2.082-1.647a1.921 1.921 0 00-2.545.144l-3.2 3.2a1.913 1.913 0 00-.144 2.545l1.742 2.2a16.482 16.482 0 00-1.572 3.991l-2.787.32a1.916 1.916 0 00-1.7 1.9v4.522a1.916 1.916 0 001.7 1.9zm16.384-12.233a7.476 7.476 0 11-7.476 7.476 7.476 7.476 0 017.476-7.476",
    fill: "#040000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageConfIcon);
export default __webpack_public_path__ + "static/media/manageConfIcon.79dd6883172b675a.svg";
export { ForwardRef as ReactComponent };